import * as THREE from 'three'
import React from 'react'
import {useGLTF} from '@react-three/drei'
import {GLTF} from 'three-stdlib'
import LevelProps from "../../../types/ThreeJsProps";
import {LEVEL_SCALE} from "../../../util/GameUtil";

type GLTFResult = GLTF & {
    nodes: {
        Lvl2_V3: THREE.Mesh
        Cube: THREE.Mesh
    }
    materials: {
        ['plaster old house']: THREE.MeshStandardMaterial
        ['Material.001']: THREE.MeshStandardMaterial
    }
}

export default function Level2({position}: LevelProps) {
    const {nodes, materials} = useGLTF('/board/level2.glb') as unknown as GLTFResult
    return (
        <group scale={LEVEL_SCALE} position={position} dispose={null}>
            <mesh geometry={nodes.Lvl2_V3.geometry} material={materials['plaster old house']} position={[0, 10.57, 0]}
                  rotation={[Math.PI / 2, 0, 0]}/>
            <mesh geometry={nodes.Cube.geometry} material={materials['Material.001']} position={[0.15, 9.75, 0.17]}
                  rotation={[-Math.PI, Math.PI / 2, 0]}/>
        </group>
    )
}

useGLTF.preload('/board/level2.glb')
